export const COLOR_HALF_ACTIVE = `hsl(var(--primary-hue),80%,85%)`
export const COLOR_ACTIVE_BACK = 'white'

export const COLOR_BACK = `hsl(var(--primary-hue),30%,98%)`
export const COLOR_TEXT = `hsl(var(--primary-hue),30%,20%)`
export const COLOR_DANGER = '#f03'
export const COLOR_SHADOW = `hsl(var(--primary-hue),30%,85%)`

export const COLOR_HEADER_SHADOW = COLOR_SHADOW
export const COLOR_HEADER_SEPARATOR = COLOR_SHADOW

export const COLOR_DROPDOWN_BACK = 'white'
export const COLOR_DROPDOWN_SHADOW = 'hsl(var(--primary-hue),30%,75%)'

export const COLOR_RESIZE_HANDLE = 'var(--primary-color)'

export const COLOR_PANEL_BACK = 'white'
export const COLOR_PANEL_SHADOW = COLOR_SHADOW

export const COLOR_ALERT_BACK = 'hsl(var(--primary-hue),100%,98%)'
export const COLOR_ALERT_SHADOW = 'hsl(var(--primary-hue),100%,50%)'
